import React from 'react';

const Tick = () => (
    <svg className="Icon Tick" fill="#ffffff" width="16" height="13" viewBox="0 0 16 13">
        <path fillRule="nonzero" d="M5.56 12.182l10.061-10.06L13.5 0 5.56 7.924 2.122 4.5 0 6.621z" />
    </svg>
);

export default Tick;
